import PortalTooltip from '@/components/PortalTooltip';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { DangerTriangleSolid } from '@mynaui/icons-react';
import { forwardRef } from 'react';

interface InputWithErrorProps extends React.ComponentProps<typeof Input> {
  label?: string;
  error?: string;
  touched?: boolean;
}

export const InputWithError = forwardRef<HTMLInputElement, InputWithErrorProps>(
  ({ label, error, touched, className, id, ...props }, ref) => {
    const showError = touched && error;
    const inputId = id || props.name;

    return (
      <div className='grid gap-2'>
        {label && <Label htmlFor={inputId}>{label}</Label>}
        <div className='relative'>
          <Input
            ref={ref}
            id={inputId}
            className={cn(showError && 'pr-8 border-rose-500 focus:border-rose-500 focus:ring-rose-500', className)}
            {...props}
          />
          {showError && (
            <>
              <PortalTooltip anchorSelect={`#${inputId}-error-icon`} content={error} place='top'></PortalTooltip>
              <div id={`${inputId}-error-icon`} className='absolute right-2.5 top-1/2 -translate-y-1/2 z-10'>
                <DangerTriangleSolid className='h-4 w-4 text-rose-500' />
              </div>
            </>
          )}
        </div>
      </div>
    );
  },
);

InputWithError.displayName = 'InputWithError';
